export default __webpack_public_path__ + "static/media/logo_black.d7851943.png";